import {
  FestivalEventBottomWrapper,
  FestivalEventBottomState,
  FestivalEventBottomButton,
} from "./style";
import { useReservation } from "../../hooks/use-reservation";
import { useMemo } from "react";
import { PubTournament } from "../../../../../api/types";
import CompanyReservationPopup from "../../../CompanyReservation/component/ReservationPopup";
import ReservationStatusPopup from "../../../CompanyReservation/component/ReservationStatusPopup";
import ReservationCancelPopup from "../../../MyReservation/component/isCancel";

interface TournamentStateBottomProps {
  tournament: PubTournament;
  getData: () => void;
}

const TournamentStateBottom = ({
  tournament,
  getData,
}: TournamentStateBottomProps) => {
  const {
    getReservationButtonText,
    handleClickStateButton,
    handleClickButton,
    canReservation,
    isReservation,
    isReservationCancel,
    setIsReservationCancel,
    handleCancel,
    isReservationPopup,
    setIsReservationPopup,
    isCurrentReservation,
    setIsCurrentReservation,
    reservationEnd,
    getEntryButtonText,
  } = useReservation(tournament);
  const currentReservations = useMemo(() => {
    if (!tournament.current) return [];
    return tournament.current.map((item, i) => {
      return {
        order: (i + 1).toString(),
        customerName: item.nickName,
        id: item.id,
        route: item.route,
      };
    });
  }, [tournament]);

  const buttonOpen = () => {
    if (!tournament.reservation) return true;
    if (tournament.isEnd) return true;
    if (reservationEnd()) return false;
    return canReservation();
  };

  return (
    <>
      {/* 예약 취소 팝업 */}
      {isReservationCancel && (
        <ReservationCancelPopup
          onClose={() => setIsReservationCancel(false)}
          handleCancel={() => {
            handleCancel();
            setTimeout(() => {
              getData();
            }, 100);
          }}
        />
      )}
      {/* 예약 팝업 */}
      {isReservationPopup && (
        <CompanyReservationPopup
          onClose={() => setIsReservationPopup(false)}
          getData={getData}
          reservationId={tournament.reservation?.id || 0}
          keepSeed={tournament.reservation?.keepSeed || 0}
          type={"reservation"}
          tournamentName={tournament.title || ""}
        />
      )}
      {/* 예약자 목록 팝업 */}
      {isCurrentReservation && (
        <ReservationStatusPopup
          reservations={currentReservations}
          onClose={() => setIsCurrentReservation(false)}
          isOpen={isCurrentReservation}
        />
      )}
      <FestivalEventBottomWrapper>
        <FestivalEventBottomState onClick={handleClickStateButton}>
          <img src="/image-web/reservation/state_button.svg" alt="state" />
          <div className="count">{getEntryButtonText(tournament)}</div>
        </FestivalEventBottomState>
        <FestivalEventBottomButton
          isOpen={buttonOpen()}
          isReservation={isReservation}
          onClick={() => {
            if (isReservation) handleClickButton();
            if (buttonOpen()) handleClickButton();
          }}
        >
          {getReservationButtonText()}
        </FestivalEventBottomButton>
      </FestivalEventBottomWrapper>
    </>
  );
};

export default TournamentStateBottom;
